/** Copy of nodeIDFromString() in Vekter NodeID.ts module */
export function nodeIdFromString(str: string): string {
    return str.replace(/^id_/, "").replace(/\\/g, "")
}
